import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetEventFlowDto {
  @IsNotEmpty()
  @IsUUID()
  id: string;
}
